// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"504":"43ed2ce6","820":"8d5364b9"}[chunkId] + ".chunk.js");